export default function getPage(value: string | number | undefined) {
  const pageNum = Number.parseInt(value?.toString() ?? "", 10);
  return Number.isNaN(pageNum) ? 1 : pageNum;
}
